import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-inventory-skeleton',
  templateUrl: './inventory-skeleton.component.html',
  styleUrls: ['./inventory-skeleton.component.scss'],
  standalone: true
})
export class InventorySkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
